<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wcinput
                    :option="{ placeholder: '请输入分类名称', clearable: true, ischange: true, isinput: true, iskeydown: true }"
                    :value="param.key"
                    @finish="(val) => {
                        if (val.type == 'input') { param.key = val.value; param.ischange = true; }
                        if (val.type == 'change') { param.key = val.value; param.ischange = true; }
                        if (val.type == 'keydown') GetList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{ title: '搜索' }" @finish="GetList" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{ title: '添加教程分类' }" @finish="openCateDialog" />
            </el-form-item>
        </el-form>
    </div>

    <div class="TTL-table top20" :ref="objloading">
        <el-table :data="list" stripe="true" empty-text="" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column prop="name" label="分类名称" align="center" />
            <el-table-column prop="sort" label="排序" align="center" width="100" />
            <el-table-column label="操作" align="center">
                <template #default="scope">
                    <div class="TTL-btn-info">
                        <wcbutton :option="{ title: '编辑' }" @finish="EditCatesData(scope.row)" />
                        <wcbutton :option="{ title: '删除', type: 'del' }" @finish="DelCates(scope.row)" class="left10" />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <wcselect
                    :option="{ placeholder: '请选择操作', ischange: true, isconfim: true }"
                    :value="handlevalue"
                    :list="handleinfos"
                    @finish="(val) => { changehandle(val.value); }"
                />
            </div>
            <div class="TTL-page TTL-page-right">
                <wcpage
                    :row="param.rows"
                    :p="param.p"
                    :rollpage="param.rollpage"
                    @finish="(val) => {
                        param.p = val.p;
                        param.rollpage = val.rollpage;
                        GetList();
                    }"
                />
            </div>
        </div>
    </div>

    <TutarialCategoryPanel
        ref="catePanel"
        variant="dialogOnly"
        @categories-updated="GetList"
    />
</template>

<script>
import INTERFACE_MODEL_TUTARIAL from '@/Interface/Es/Tutarial';
import TutarialCategoryPanel from './components/TutarialCategoryPanel.vue';

export default {
    components: {
        TutarialCategoryPanel,
    },
    data() {
        return {
            objloading: 'tutarialcates',
            param: {
                key: '',
                p: 1,
                rollpage: 10,
                ischange: false,
                rows: 0,
            },
            list: [],
            handlevalue: '',
            handleinfos: [
                { id: 1, name: '批量删除数据' },
            ],
        };
    },
    mounted() {
        this.OnloadMethod();
    },
    methods: {
        OnloadMethod() {
            this.GetList();
        },
        BrotherComponentIn() {
            this.GetList();
        },
        openCateDialog() {
            if (this.$refs.catePanel) this.$refs.catePanel.openDialog();
        },
        GetList() {
            if (this.param.ischange) {
                this.param.ischange = false;
                this.param.p = 1;
                this.param.rollpage = 10;
            }
            var obj = this.$refs[this.objloading];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_TUTARIAL.GET_TUTARIAL_CATE_LIST(this.param).then((res) => {
                this.$loading.closeloading(obj);
                if (res.status > 0) return false;
                this.param.rows = res.data.count;
                this.list = res.data.list;
            });
        },
        selecttable(val) {
            for (var i = 0; i < this.list.length; i++) this.list[i].isshow = false;
            for (var i = 0; i < val.length; i++) val[i].isshow = true;
        },
        DelCates(row) {
            if (this.$refs.catePanel) {
                this.$refs.catePanel.handleDeleteCate(row);
            }
        },
        EditCatesData(row) {
            if (this.$refs.catePanel) this.$refs.catePanel.openDialog(row);
        },
        DelCatesData(ids) {
            this.$confirm
                .confirm('确定删除选中的分类吗？删除后不可恢复。', '删除提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                })
                .then(() => {
                    INTERFACE_MODEL_TUTARIAL.DEL_TUTARIAL_CATE({ ids: ids }).then((res) => {
                        if (res.status > 0) return false;
                        this.param.ischange = true;
                        this.GetList();
                        if (this.$refs.catePanel) this.$refs.catePanel.reloadCategories();
                        if (this.$method && this.$method.GET_TUTARIAL_CATES) this.$method.GET_TUTARIAL_CATES(true);
                    });
                })
                .catch(() => {});
        },
        changehandle(index) {
            var ids = this.GetSelectDataIds();
            if (ids.length == 0) {
                this.$notice({ title: '消息提示', message: '请选择要批量执行的数据', type: 'warning' });
                return false;
            }
            ids = ids.join(',');
            if (index == 1) this.DelCatesData(ids);
        },
        GetSelectDataIds() {
            var ids = [];
            ids = this.list.map((obj) => (obj.isshow ? obj.id : ''));
            ids = ids.filter((element) => element !== null && element !== '');
            return ids ? ids : [];
        },
    },
};
</script>
<style scoped>
.TTL-btn-info {
    display: inline-flex;
}
</style>
